export default Buffer.from("A+BSQ29weXJpZ2h0IDE5OTAtMjAwOSBBZG9iZSBTeXN0ZW1zIEluY29ycG9yYXRlZC4KQWxsIHJpZ2h0cyByZXNlcnZlZC4KU2VlIC4vTElDRU5TReEGQ05TMS1IYQwhLADqTg4AfAEAfgABgQICAYEGAgGBCgIBgQ4CAYESAgGBFgIBgRoCAYEegWgA6k8=", "base64")


//////////////////
// WEBPACK FOOTER
// ./~/vue-pdf-signature/src/buffer-loader.js!./~/pdfjs-dist-sign/cmaps/CNS1-V.bcmap
// module id = 620
// module chunks = 502